import { collectSort, FeaturedContent } from './featured-content';
import { navigate, subscribe } from './featured-content/featured-content-service';
import { filterItem } from './featured-content/featured-content-templates';

const selectors = {
  main: '.c-featured-navigation-sub-filter',
  trigger: '.c-featured-navigation-sub__heading > a',
  subheading: '.c-featured-navigation-sub__subheading',
};

export const collectFilters = () => {
  return Object.fromEntries(
    [...document.querySelectorAll(selectors.main)].map(filters => ([
      filters.dataset.filterKey,
      [...filters.querySelectorAll('input[type=checkbox]:checked')].map(check => check.value),
    ])).filter(([,value]) => !Array.isArray(value) || value.length)
  );
};

class FeaturedFilter {
  constructor($el) {
    this.id = new URLSearchParams(document.location.search).get('id');
    this.container = $el;
    this.filterKey = $el.dataset.filterKey;
    this.list = $el.querySelector('ul');
    this.trigger = $el.querySelector(selectors.trigger);
    this.items = $el.querySelectorAll('input[type=checkbox]');
    this.subheading = $el.querySelector(selectors.subheading);

    this.setupExpandToggle();
    this.setupFilteringEvents();

    subscribe((data, { id, type }) => {
      this.id = id;

      if (type === 'loadmore') {
        return;
      }
      this.populateFilters(data[this.filterKey]);
      this.setupFilteringEvents();
    });
  }

  setupExpandToggle() {
    this.trigger.addEventListener('click', e => {
      e.preventDefault();

      const hiddenString = this.list.getAttribute('aria-hidden') || '';
      const hidden = hiddenString === ''
        ? matchMedia('screen and (max-width: 1024px)').matches
        : hiddenString !== 'false';

      this.list.setAttribute('aria-hidden', String(!hidden));
      this.subheading.setAttribute('aria-hidden', String(!hidden));
      this.container.setAttribute('aria-expanded', String(hidden));
    });
  }

  setupFilteringEvents() {
    const handler = e => {
      const pageSize = FeaturedContent.pageSize();
      FeaturedContent.hide();
      navigate({
        id: this.id,
        page: 1,
        pageSize,
        type: 'filter',
      }, collectFilters(), collectSort());
    };

    this.items.forEach(item => item.addEventListener('change', handler));
  }

  populateFilters(filters) {
    const templateContainer = document.createElement('template');
    templateContainer.innerHTML = filters
      .map(filter => filterItem(filter))
      .join('');

    this.list.replaceChildren(templateContainer.content);
    this.items = this.container.querySelectorAll('input[type=checkbox]');
    this.container.setAttribute('aria-hidden', filters.length === 0);
  }
}

document.querySelectorAll(selectors.main).forEach($el => new FeaturedFilter($el));
